import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { UserService } from 'app/core/user/user.service';

@Injectable({
    providedIn: 'root',
})
export class HomeRedirectGuard implements CanActivate {
    constructor(
        private readonly userService: UserService,
        private readonly router: Router,
    ) {}

    canActivate(): boolean {
        this.router.navigateByUrl('/apps/innovation/new');
        return false;
    }
}
